export default "__VITE_ASSET__QJnmXYPX__"